export default __webpack_public_path__ + "static/media/single_side_crushers_start.8e51c096.svg";